<template>
    <div class="shop_head">
        <div v-show="center_top">
            <head-top></head-top>
            
            <div class="center_top width_center_1200" >
                <div class="shop_logo float_left">
                    <router-link to="/"><img width="240px" height="74px" src="/pc/logo.png" alt="科欣医药"></router-link>
                </div>
                <div class="shop_top_seach float_left">
                    <ul>
                        <li>
                            <el-autocomplete
                            v-show="center_top"
                            class="search_input search-text"
                            v-model="keyword"
                            :fetch-suggestions="querySearch"
                            maxlength="30" 
                            placeholder="请输入关键词搜索"
                            :trigger-on-focus="false"
                            @keyup.enter="search" 
                            @select="handleSelect"
                            @focus="groupListMe"
                            ></el-autocomplete>
                        </li>
                        <li>
                            <button type="button" class="button button-goods"  @click="search()"><i class="icon iconfont">&#xeba0;</i>搜 索</button>
                        </li>
                        <li>
                            <div class="index_my_car">
                                <span @click="to_my_cart()">我的购物车<i class="icon iconfont">&#xe602;</i><div class="shop_car_dot">{{cart_count || 0}}</div></span>
                            </div>
                        </li>
                        <li><p class="net" style="width:85px; margin-left:20px; border: 1px solid #409EFF; border-radius: 8px; padding:1px 10px;"><a href="/pc/互联网药品信息服务资格证书正本20180328.jpg" target="_blank" style="color: #409EFF; ">互联网药品信息服务资格证书</a></p></li>
                    </ul>

                    <ul class="keyword" >
                        <li v-for="(v,k) in hotlist" :key="k"><a :href="v.hrefurl" target="_bank">{{v.name}}</a></li>
                    </ul>

                </div>
            </div>
        </div>
        <!-- nav -->
        <div class="shop_top_nav floor-item">
            <div class="width_center_1200">
                <div class="shop_top_nav_left" @mouseover="subnav_show?subnav:subnav=true" @mouseleave="subnav_show?subnav:subnav=false">
                    <a href="/goods/params/?keyword=" class="allgoods"><i class="el-icon-menu"></i>全部商品分类</a>
                    <transition name="el-zoom-in-top"><leftBar :change_color="change_color" v-show="subnav"></leftBar></transition>
                </div>
                <div class="shop_top_nav_right">
                    <ul>
                        <li><router-link to="/">首页</router-link></li>
                        <li><a href="/event/gather">活动集合</a></li>
                        <li><a href="/special/list/MjAyMDA5MjdfOA==">保健品</a></li>
                        <li><a href="/special/list/MjAyMDA5MjdfOQ==">医疗器械</a></li>
                        <li><a href="/special/list/MjAyMDA5MjdfMTA="><img src="/pc/2020/imgs/fire.png">饮片直销</a></li>
                        <li><a href="/control/">精品控销</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import leftBar from "@/components/home/public/leftbar.vue"
import HeadTop from "@/components/home/public/head_top.vue"
// import { config } from 'vue/types/umd';
// import chat from "@/components/chat/index.vue";
export default {
    inject:['reload'],
    components: {
        leftBar,
        HeadTop,
        // chat
    },
    props: {
        subnav_show:{
            type:Boolean,
            default:true,
        },
        change_color:{
            type:Boolean,
            default:false,
        },
        cart_change:{
            type:Number,
        }
    },
    data() {
      return {
          subnav:true,
          keyword:'',
          cart_count:0,
          center_top:true,
          hotlist:[],
          paramsInfo:[],
          restaurant:[],
          restaurants:null,
          groupList:[],
          value:null
      };
    },
    watch: {
        subnav_show:function(val){
            this.subnav = val;
        },
        cart_change:function(){
            this.get_cart_count();
        },
    },
    computed: {},
    methods: {

        querySearch(queryString, cb) {
        if (queryString != "") {
            // 输入内容以后才去做模糊查询
            setTimeout(() => {
            let callBackArr = []; // 准备一个空数组，此数组是最终返给输入框的数组
            // 这个res是发请求，从后台获取的数据
                this.$get(this.$api.queryDeduplication,{keyword:queryString,platId:this.$platId}).then(res=>{
                    if(res.code == 200){
                        if(res.data.length > 0){
                            // var arr = [];
                            // for (var i = 0; i < this.list.length; i++) {
                            //     for (var j = i + 1; j < this.list.length;) {
                            //         //去重
                            //         if (this.list[i].name == this.list[j].name) {
                            //             this.list.splice(j, 1)
                            //         } else {
                            //             j++
                            //         }
                            //     }    
                            //     //数组重组
                            //     arr.push({
                            //         value:this.list[i].name,
                            //         // id:this.list[i].id
                            //     })
                            // }
                            this.groupList = res.data;
                            this.groupList.forEach((item) => {
                            if (item.value.indexOf(queryString) > -1) {
                                callBackArr.push(item); 
                            }
                            if(callBackArr.length > 0){
                                cb(callBackArr);
                            }else{
                                cb([]);
                            }
                            });
                        }else{
                            cb([]);
                            this.$message.error('暂无数据!');
                        }

                    }
                });


            }, 1500);
        }
        },
        handleSelect(item) {
            if(item.value==''){
            }else{
            if(this.$route.name == 'goods_index'){
                let params = 'keyword='+item.value;
                this.$router.push('/goods/params/?'+params);
                this.$router.go(0)
            }
                let params = 'keyword='+item.value;
                this.$router.push('/goods/params/?'+params);
            }
        },

        search:function(){
            if(this.keyword==''){
            }else{
            if(this.$route.name == 'goods_index'){
                // return this.$emit('search_goods',{keyword:this.keyword});
            let params = 'keyword='+this.keyword;
            this.$router.push('/goods/params/?'+params);
            this.$router.go(0)
            }
            let params = 'keyword='+this.keyword;
            this.$router.push('/goods/params/?'+params);
            }

        },


        get_cart_count:function(){
            if(this.$isEmpty(localStorage.getItem('token'))){
                return;
            }
            this.$get(this.$api.homeGetCartCount,{platId:this.$platId}).then(res=>{
                if(res.code == 200){
                    this.cart_count = res.data;
                }else{
                    this.cart_count = 0
                }
            });
        },
        to_my_cart:function(){
            if(this.$isEmpty(localStorage.getItem('token'))){
                this.$message.error('请先登录！');
                return this.$router.push('/user/login');
            }else{
                return this.$router.push('/cart/index');
            }
        },

        get_keywords:function(){
            // if(this.$route.params.info.split("=")[1] != null){
            //     this.keyword = this.$route.params.info.split("=")[1];
            // }
            let params = this.$route.params.info;
            if(this.$isEmpty(params)){
                return;
            }
            //let paramsArr = params.split('|');
            paramsArr.forEach(res=>{
                let paramsInfo = [];
                paramsInfo = res.split('=');
                if(paramsInfo[0] == 'keywords'){  // 搜索关键词
                    if(paramsInfo.length==2){
                        this.keyword = paramsInfo[1];
                    }else{
                        this.keyword = '';
                    }
                }
            });
        },
        //热门搜索
        hotGoodsListAll:function(){
            this.$get(this.$api.hotGoodsListAll,{platId:this.$platId}).then(res=>{
                this.hotlist = res.data.list;
            });
        },
        searchEnterFun:function(e){
            // 使用 which 和 keyCode 属性来解决兼容问题
            var keyCode = window.event? e.keyCode:e.which;
            var val = e.target.value;
            //console.log('回车搜索',keyCode,e);
            if(keyCode == 13 && val){
                this.get_keywords();
            }
        },

    },
    created() {
        this.hotGoodsListAll();
        this.subnav = this.subnav_show;
        this.get_cart_count();
        //this.get_keywords();

        // 监听滚动条
        window.addEventListener('scroll', ()=>{
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            if(scrollTop>210){
                this.center_top = false;
                // document.querySelector("el-autocomplete-suggestion").style.display='none'
            }else{
                this.center_top = true;
            }
        }, true);
    },
    mounted() {
        // this.restaurants = this.groupList;
    }
};
</script>
<style lang="scss" scoped>
.shop_head{
    z-index: 666;
    position: fixed;
    background: #fff;
    left:0;
    right: 0;
}

.center_top:after{
    display: block;
    clear:both;
    content:'';
}

.shop_logo{
    margin-top: 30px;
    margin-bottom: 30px;
}
.shop_top_nav{
    height: 40px;
    background:#fff;
    font-size: 14px;
    line-height: 40px;
    border-bottom: 2px solid #409EFF;
    z-index: 9999;
    // box-shadow: 0 0 10px 2px rgba(90,90,90,.6);
    color:#555;
    .shop_top_nav_left{
        float: left;
        width: 240px;
        background:#409EFF;
        box-sizing: border-box;
        // padding-left: 15px;
        position: relative;
        color:#fff;
        font-size: 16px;
        font-weight: 700;
        text-align: center;
        height: 40px;
        line-height: 40px;
        i{
            font-size: 18px;
            margin-right: 10px;
            height: 40px;
            line-height: 40px;
        }
    }
    .shop_top_nav_right{
        padding-left: 20px;
        float: left;
        ul li{
            float: left;
            margin: 0 10px;
        }
        ul li a{
            line-height: 40px;
            padding:0 30px;
            font-size: 16px;
            color:#555;
            display: block;
            font-weight: bold;
        }
        ul li a:hover{
            // background: #000;
            color: #409EFF;
        }
    }
}
.shop_top_seach{
    margin-top: 44px;
    margin-left: 120px;
    width: 835px;
    ul li{
        float: left;
        cursor: pointer;
    }
    .search_input{
        width: 434px;
        height: 44px;
        line-height: 38px;
        outline: 0;
        border: 2px solid #409EFF;
        border-right: none;
        float: left;
        box-sizing: border-box;
        font-size: 14px;
        border-radius: 8px 0 0 8px;
        color: #b8b8b8;
    }
    .search_button{
        border: 1px solid #efefef;
        float: left;
        width: 38px;
        height: 48px;
        background: #fff;
        outline: 0;
        text-align: center;
        cursor: pointer;
    }
    .search_button:hover{
        color:#fff;
        background:#333;
    }
    .index_my_car{
        height: 44px;
        border: 1px solid #efefef;
        margin-left: 10px;
        box-sizing: border-box;
        font-size: 14px;
        line-height: 44px;
        padding: 0 20px;
        border-radius: 8px;
        span:hover{
            color:#409EFF;
        }
        span{
            margin-right: 20px;
            position: relative;
            font-size: 14px;
            font-family: Microsoft YaHei;
            i{
                font-size: 16px;
                margin-left: 6px;
            }
            a:hover{
                color:#409EFF;
            }
            .shop_car_dot {
                position: absolute;
                top: -24px;
                line-height: 16px;
                background: #409EFF;
                padding: 0 4px;
                color: #fff;
                border-radius: 4px;
                right: -10px;
            }
        }
        span:last-child{
            margin-right: 0;
            i{
                font-size: 18px;
            }
        }
        
    }
}
a.allgoods{
    color:#fff;
}
</style>

<style>
/*搜索下拉推荐*/
.shop_top_seach input{
    border: none;
}
.shop_top_seach .el-input--small .el-input__inner{
    height: 40px !important;
    line-height: 40px !important;
    border-radius: 8px 0 0 8px !important;
}
/* .el-autocomplete-suggestion{

} */
.net a:hover{color: #409EFF;}
</style>